// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8298d98","root":"_2e9daad","avatar":"_8fa729a"};